import React, {useEffect, useState} from "react";
import "./fuelIndicator.css";
import key_fuel_level_img from "../../../../assets/images/keyless-return/fuel_level.svg";
import key_electric_img from "../../../../assets/images/keyless-return/electrical_services.svg"
import {FuelType} from "../useKeylessReturn";

export function FuelIndicator(
  {
    fuelType,
    fuelLevel,
    setFuelLevel,
    isEditing,
    onInteractStart,
    onInteractEnd,
  }
) {
  const marks = [0, 1, 2, 3, 4, 5, 6, 7, 8];
  // O cartão do combustível não tem botão de editar: considera-se em edição enquanto
  // o manípulo do slider está premido E a ser movido.
  const [pressed, setPressed] = useState(false);

  useEffect(() => {
    if (!pressed) return undefined;
    // O fim do arrasto pode acontecer fora do input (o manípulo captura o ponteiro),
    // por isso ouve-se no window em vez de só no próprio input.
    const endInteraction = () => {
      setPressed(false);
      if (onInteractEnd) onInteractEnd();
    };
    window.addEventListener("pointerup", endInteraction);
    window.addEventListener("pointercancel", endInteraction);
    window.addEventListener("touchend", endInteraction);
    window.addEventListener("touchcancel", endInteraction);
    window.addEventListener("mouseup", endInteraction);
    return () => {
      window.removeEventListener("pointerup", endInteraction);
      window.removeEventListener("pointercancel", endInteraction);
      window.removeEventListener("touchend", endInteraction);
      window.removeEventListener("touchcancel", endInteraction);
      window.removeEventListener("mouseup", endInteraction);
    };
  }, [pressed, onInteractEnd]);

  const handleChange = (e) => {
    setFuelLevel(Number(e.target.value));
    // Só sinaliza edição se o valor mudou com o manípulo premido (arrasto),
    // e não em alterações por teclado.
    if (pressed && onInteractStart) onInteractStart();
  };

  return (
    <div className={`fuel-card${isEditing ? " is-editing" : ""}`}>
      <img
        src={fuelType === FuelType.ELECTRIC ? key_electric_img : key_fuel_level_img}
        alt="key fuel"
        className="card-icon"
      />

      <div className="numbers-row">
        {marks.map((num) => (
          <div
            key={num}
            className="number-circle"
            style={{left: `${(num / 8) * 100}%`}}
          >
            {num}
          </div>
        ))}
      </div>

      <div className="slider-wrapper">
        <input
          type="range"
          min="0"
          max="8"
          value={fuelLevel}
          onChange={handleChange}
          onPointerDown={() => setPressed(true)}
          onTouchStart={() => setPressed(true)}
          onMouseDown={() => setPressed(true)}
          className="invisible-slider"
        />

        <div className="visual-track">
          <div
            className="visual-fill"
            style={{width: `${(fuelLevel / 8) * 100}%`}}
          ></div>

          <div className="thumb-left"></div>

          <div
            className="thumb-right"
            style={{left: `${(fuelLevel / 8) * 100}%`}}
          ></div>
        </div>
      </div>
    </div>
  );
}
